var render = function render(){var _vm=this,_c=_vm._self._c;return _c('activation-modal',{attrs:{"name":"autopilot-toggle-modal","title":_vm.modalConfig.title,"description":_vm.modalConfig.description,"cancel-text":"dashboard.universkinSupport.modal.cancel","confirm-text":_vm.modalConfig.confirmActionLabel},on:{"cancel":_vm.onCancel,"confirm":_vm.onConfirm,"before-open":_vm.onBeforeOpen}})
}
var staticRenderFns = []

export { render, staticRenderFns }